export const MIN_INFERENCES_SAMPLE = 10;
